import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { formatDescription } from '../../../../../lib/utils/utils';

function AboutTwo({ item }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [headingSize, setHeadingSize] = useState(0);
    const [headingHeight, setHeadingHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descHeight, setDescHeight] = useState(0);

    const [textGap, setTextGap] = useState(0);

    const [paddingSide, setPaddingSide] = useState(0);

    useEffect(() => {
        setHeadingSize((zoomSize/100)*20);
        setHeadingHeight((zoomSize/100)*28);

        setDescSize((zoomSize/100)*14);
        setDescHeight((zoomSize/100)*26);

        setTextGap((zoomSize/100)*4);

        setPaddingSide((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div 
            style={{ paddingLeft: `${paddingSide}px`, paddingRight: `${paddingSide}px` }} 
            className='flex flex-col gap-1 relative'
        >
            <div style={{ gap: `${textGap}px` }} className="flex flex-col">
                <h1 style={{ fontSize: `${headingSize}px`, lineHeight: `${headingHeight}px` }} className='text-[#212121] font-medium'>{item.item.Heading}</h1>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descHeight}px` }} className='text-[#212121] font-normal'>
                    <span dangerouslySetInnerHTML={{ __html: formatDescription(item.item.Description || '') }} />
                </p>
            </div>
        </div>
    );
}

export default AboutTwo;
